/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import { connect } from 'react-redux';
import { lazy, Suspense, useEffect } from 'react';
import 'typeface-roboto';
import 'typeface-noto-sans';
import "@fontsource/source-sans-pro"
import "@fontsource/source-sans-pro/200.css"
import "@fontsource/source-sans-pro/300.css"
import "@fontsource/source-sans-pro/600.css"
import "@fontsource/source-sans-pro/700.css"
import "@fontsource/source-sans-pro/900.css"

import { ThemeProvider } from '@mui/material/styles';

// Rapids GUI Library
import { ProvideTheme, Button } from 'rapids-gui-library';
import { RapidsAgentTheme, RapidsAgentDarkTheme, RapidsChallengeTheme } from 'rapids-gui-library';

// App Components
import Challenge from "./sites/challenge";
import AgentAndRapids from "./sites/agent_and_rapids";

global.is_logged_in_secure = false;

function App({userInfo, pageInfo, theme, ...props}) {
  // console.log(ProvideTheme, RapidsAgentTheme, RapidsAgentDarkTheme, RapidsChallengeTheme);

  return (<>
    {(window._env_.APP_SITE === 'agent' || window._env_.APP_SITE === 'rapids') &&
      <ProvideTheme themeType={theme}>
        <ThemeProvider theme={theme === 'dark' ? RapidsAgentDarkTheme : RapidsAgentTheme}>
          <AgentAndRapids />
        </ThemeProvider>
      </ProvideTheme>
    }
    {(window._env_.APP_SITE === 'challenge') &&
      <ProvideTheme themeType={'challenge'}>
        <ThemeProvider theme={RapidsChallengeTheme}>
          <Challenge/>
        </ThemeProvider>
      </ProvideTheme>
    }
  </>);
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo,
    pageInfo: state.pageInfo,
    theme: state.theme,
  }
}

export default connect(mapStateToProps)(App);
